/*
上传文件相关api及地址配置
 */
import request from './request';

export const uploadApi = {
  aliyunUrl: '/v2/s/image/AliYunImgUpload',
  normalUrl: '/v2/s/image/commonImgUpload',
  // 预上传接口，在真正上传之前需要获取一些阿里云数据
  preUpload (type = null) {
    return request({
      url: '/kyc/get/preupload',
      method: 'get',
      params: {
        type,
      },
    });
  },
};
